import React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { DialogActions, DialogContentText } from '@mui/material';
import CancelIcon from '@mui/icons-material/Replay';
import UnarchiveIcon from '@mui/icons-material/Unarchive';
import { FeedbackSnackbarContext } from '../../../context/FeedbackSnackbarContext';
import { MetadataError } from '@ep/error-handling';
import { generateUuidV4 } from '../../../util/uuid';
import { log } from '../../../util/log';
import GhostButton from '../button/GhostButton';
import PrimaryButton from '../button/PrimaryButton';

const UnarchiveConfirmModal = ({
  open,
  unarchive_label,
  unarchive_explainer,
  handleCloseUnarchiveModal,
  handleUnarchive
}: {
  open: boolean;
  unarchive_label?: string | null;
  unarchive_explainer?: string;
  handleCloseUnarchiveModal: () => void;
  handleUnarchive?: (() => void) | null;
}) => {
  const [unarchiveLoading, setUnarchiveLoading] = React.useState(false);
  const { setFeedbackData } = React.useContext(FeedbackSnackbarContext);

  const handleUnarchiveClick = async () => {
    setUnarchiveLoading(true);
    try {
      if (handleUnarchive) {
        await handleUnarchive();
      }
      handleCloseUnarchiveModal();
    } catch (err: unknown) {
      const tracking_id: string = generateUuidV4();
      log(
        'error',
        new MetadataError(
          err instanceof Error
            ? err.message
            : 'Error: UnarchiveConfirmModal failed on an unknown error while calling handleUnarchiveClick.',
          null,
          tracking_id
        )
      );
      setFeedbackData({
        message: `Unable to unarchive entities. Tracking ID: ${tracking_id}`,
        state: true,
        type: 'error'
      });
    } finally {
      setUnarchiveLoading(false);
    }
    return;
  };

  return (
    <Dialog open={open} onClose={handleCloseUnarchiveModal}>
      <DialogTitle>{`Are you sure you want to Restore ${unarchive_label} from Archived?`}</DialogTitle>
      <DialogContent>
        <DialogContentText id="unarchive-explainer">{unarchive_explainer}</DialogContentText>
        <br />
        <DialogActions>
          <GhostButton dark startIcon={<CancelIcon />} onClick={handleCloseUnarchiveModal}>
            Cancel
          </GhostButton>
          {handleUnarchive && (
            <PrimaryButton
              loading={unarchiveLoading}
              startIcon={<UnarchiveIcon />}
              onClick={async () => {
                await handleUnarchiveClick();
              }}
              palette_color="info"
              autoFocus
            >
              Restore
            </PrimaryButton>
          )}
        </DialogActions>
      </DialogContent>
    </Dialog>
  );
};

export default UnarchiveConfirmModal;
